import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';

export default class PageLinkRoute extends Route {
  @service('router') router;
  beforeModel(transition) {
    this.router.replaceWith('client-app', {
      queryParams: transition.to?.queryParams ?? {},
    });
  }
}
